import { CONCEPT_VALUE_ALL_OPTION } from "../constants";

/** Split stored Reference Value codes (`a,b` or `__all__`). */
export function parseObjectSubTypeCodes(raw: string): string[] {
  const trimmed = raw.trim();
  if (!trimmed) return [];
  if (
    trimmed.toLowerCase() === CONCEPT_VALUE_ALL_OPTION.code.toLowerCase()
  ) {
    return [CONCEPT_VALUE_ALL_OPTION.code];
  }
  return trimmed
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);
}

/** Persist multi-select Reference Values into the singular `objectSubType` field. */
export function serializeObjectSubTypeCodes(
  codes: readonly string[],
  allValues = false,
): string {
  if (allValues) return CONCEPT_VALUE_ALL_OPTION.code;
  const unique: string[] = [];
  const seen = new Set<string>();
  for (const code of codes) {
    const trimmed = code.trim();
    if (!trimmed) continue;
    const key = trimmed.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    unique.push(trimmed);
  }
  return unique.join(",");
}
